// ============================================================
// COMMENTED OUT — 09/06/2025 — 02:30 PM IST
// Reason: handleSubmit was only resetting form and closing popup.
//         No email was being sent. Added EmailJS integration below.
// ============================================================

// import React, { useState } from "react";
// import "./popup.css";
//
// const PopupForm = ({ onClose }) => {
//   const [formData, setFormData] = useState({
//     name: "", email: "", phone: "", webinarInterest: "", questions: ""
//   });
//
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };
//
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setFormData({ name: "", email: "", phone: "", webinarInterest: "", questions: "" });
//     onClose();
//   };
//
//   return (
//     <div className="popup-overlay">
//       <div className="popup-form">
//         <button className="close-btn" onClick={onClose}>×</button>
//         <h2>Register for Webinar</h2>
//         <p>Provide your details and share your learning goals.</p>
//         <form onSubmit={handleSubmit}>
//           <label htmlFor="name">Full Name
//             <input type="text" id="name" name="name" value={formData.name}
//               onChange={handleChange} placeholder="Please enter your full name" required />
//           </label>
//           <label htmlFor="email">Email
//             <input type="email" id="email" name="email" value={formData.email}
//               onChange={handleChange} placeholder="Please enter your email address" required />
//           </label>
//           <label htmlFor="phone">Phone
//             <input pattern="[0-9]{10}" type="tel" id="phone" name="phone"
//               value={formData.phone} placeholder="Please enter your phone number" onChange={handleChange} />
//           </label>
//           <label htmlFor="webinarInterest">What interests you most about this webinar?
//             <select name="webinarInterest" id="webinarInterest"
//               value={formData.webinarInterest} onChange={handleChange} required>
//               <option value="">Select one</option>
//               <option value="market-basics">Understanding market basics</option>
//               <option value="risk-management">Risk management strategies</option>
//               <option value="trading-discipline">Building trading discipline</option>
//               <option value="algo-awareness">Quant & Algo awareness</option>
//             </select>
//           </label>
//           <label htmlFor="questions">Any specific questions you want addressed?
//             <textarea name="questions" id="questions" value={formData.questions}
//               onChange={handleChange} placeholder="Write your question here..." />
//           </label>
//           <button type="submit" className="submit-btn">Submit</button>
//         </form>
//       </div>
//     </div>
//   );
// };
//
// export default PopupForm;

// ============================================================
// NEW CODE — 09/06/2025 — 02:30 PM IST
// Reason: Integrated EmailJS to send form data to
//         niteshsawardekar972@gmail.com on every submission
// Service ID: service_n1y2oj6 | Template ID: template_d4m53un
// ============================================================

import React, { useState } from "react";
import "./popup.css";
import emailjs from "@emailjs/browser";

const PopupForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    webinarInterest: "",
    questions: ""
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");

    emailjs
      .send(
        "service_n1y2oj6",
        "template_d4m53un",
        {
          from_name:        formData.name,
          from_email:       formData.email,
          phone:            formData.phone,
          webinar_interest: formData.webinarInterest,
          questions:        formData.questions,
        },
        "m0mOnnwsWbEAL8gVf"
      )
      .then(() => {
        setStatus("success");
        setFormData({ name: "", email: "", phone: "", webinarInterest: "", questions: "" });
        setTimeout(onClose, 2000);
      })
      .catch(() => {
        setStatus("error");
      });
  };

  return (
    <div className="popup-overlay">
      <div className="popup-form">
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>Register for Webinar</h2>
        <p>Provide your details and share your learning goals.</p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="name">
            Full Name
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Please enter your full name"
              required
            />
          </label>

          <label htmlFor="email">
            Email
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Please enter your email address"
              required
            />
          </label>

          <label htmlFor="phone">
            Phone
            <input
              pattern="[0-9]{10}"
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              placeholder="Please enter your phone number"
              onChange={handleChange}
            />
          </label>

          <label htmlFor="webinarInterest">
            What interests you most about this webinar?
            <select
              name="webinarInterest"
              id="webinarInterest"
              value={formData.webinarInterest}
              onChange={handleChange}
              required
            >
              <option value="">Select one</option>
              <option value="Understanding Market Basics">Understanding market basics</option>
              <option value="Risk Management Strategies">Risk management strategies</option>
              <option value="Building Trading Discipline">Building trading discipline</option>
              <option value="Quant & Algo Awareness">Quant & Algo awareness</option>
            </select>
          </label>

          <label htmlFor="questions">
            Any specific questions you want addressed?
            <textarea
              name="questions"
              id="questions"
              value={formData.questions}
              onChange={handleChange}
              placeholder="Write your question here..."
            />
          </label>

          <button type="submit" className="submit-btn" disabled={status === "sending"}>
            {status === "sending" ? "Sending..." : "Submit"}
          </button>

          {status === "success" && (
            <p style={{ color: "green", marginTop: "10px", textAlign: "center" }}>
              ✅ Registered successfully! We'll be in touch soon.
            </p>
          )}
          {status === "error" && (
            <p style={{ color: "red", marginTop: "10px", textAlign: "center" }}>
              ❌ Something went wrong. Please try again.
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default PopupForm;
